import React, { useState , useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const MyMarket = () => {
 const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
 const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h5 className="m-0">Manage Fancy</h5>
        </div>
        <section className="content">
          <div className="mt-2 tophead d-flex justify-content-between">
            <div className="d-flex align-items-center cursor-pointer justify-content-center">
              <div className="top px-3">All</div>
              <div className="top px-2">
                <img src="/assets/images/crickball1.png" height="20px" width="20px" alt="" />
                Cricket
              </div>
              <div className="top px-2">
                <img src="/assets/images/tennis1.png" height="20px" width="20px" alt="" />
                Tennis
              </div>
              <div className="top px-2">
                <img src="/assets/images/soccer1.png" height="19px" width="19px" alt="" />
                Soccer
              </div>
              <div className="top px-2">
                <img src="/assets/images/vote.png" height="19px" width="19px" alt="" />
                Election
              </div>
            </div>
            <button
              type="button"
              className="btn btn-sm btn-primary refreshButton px-3 py-1"
            >
              Refresh
            </button>
          </div>
          <div className="table-responsive">
            <table
              role="grid"
              className="table table-hover datatable table-striped mt-4"
            >
              <thead className="bg-dark">
                <tr>
                  <th>Series Name</th>
                  <th>Match Name</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr></tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <a
        id="back-to-tops"
        href="##"
        className="btn btn-primary back-to-top"
        role="button"
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up" />
      </a>
    </div>
  );
};

export default MyMarket;
